import React, { useCallback } from 'react';
import { Box, Option, PencilIcon, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ProviderOptionMetadata } from './useProviderOptions';

const EditProviderButton = styled(RawButton)`
  display: none;
`;

const StyledOptionWrapper = styled(Box)`
  &:hover > ${EditProviderButton} {
    display: flex;
  }
`;

interface Props {
  onEditProvider: (providerId?: string) => void; 
}

const useProviderOptionRenderWrapper = ({ onEditProvider }: Props) => {
  const providerOptionRenderWrapper = useCallback((option: Option) => {
    const providerMetadata = option?.metadata as ProviderOptionMetadata;

    return (
      <StyledOptionWrapper width="100%" direction="row" align="center" justify="between">
        <Box>
          <Text
            data-testId={`${option?.key}_dropdown-input_option-title`} 
            weight={400}
          >
            {option?.title}
          </Text>
          <Text
            data-testId={`${option?.key}_dropdown-input_option-provider-address`} 
            weight={400}
            color="textSecondary"
          >
            {providerMetadata?.providerAddress}
          </Text>
        </Box>
        <EditProviderButton
          data-testId={`${option?.key}_dropdown-input_option-provider-edit_button`} 
          onClick={() => onEditProvider(option?.key as string)}
        >
          <PencilIcon size="16px" />
        </EditProviderButton>
      </StyledOptionWrapper>
    );
  }, [onEditProvider]);

  return {
    providerOptionRenderWrapper,
  };
};

export default useProviderOptionRenderWrapper;
